import { render, staticRenderFns } from "./wt9.vue?vue&type=template&id=5b941ec2&scoped=true&"
import script from "./wt9.vue?vue&type=script&lang=js&"
export * from "./wt9.vue?vue&type=script&lang=js&"
import style0 from "./index.css?vue&type=style&index=0&id=5b941ec2&prod&scoped=true&lang=css&"
import style1 from "./wt9.vue?vue&type=style&index=1&id=5b941ec2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b941ec2",
  null
  
)

export default component.exports